<template>
<div class="columns">
<section class="section column is-2 menu-background">
<Menu />
</section>
<section class="column is-10">
    
    <div class="navbar-custom-pc">
        <NavBar />
    </div>
   

<div>
     <div class="level">
     <div class="level-left">
       <div class="level-item">
         <span class="is-size-3 has-text-weight-bold">Home</span>
       </div>
     </div>
   </div>
   <div class="columns">
      <div class="column is-3">
        <Card icon="city" property="Total Products" :value="data[0].total_products" firstColor="#24C6DC" secondColor="#514A9D" />
      </div>
      <div class="column is-3">
        <Card icon="building" property="Total Family" :value="data[0].total_family" firstColor="#000046" secondColor="#1CB5E0" />
      </div>
     
   </div>
   </div>
</section>
</div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Card from '@/components/Card.vue'
import Menu from '@/components/Menu.vue'

export default {
  name:'Home',
    data()    {
        return {
data:[{
      "total_products":0,
      "total_family":0,
    }],
        }
    },
    components:{
        Card,
        NavBar,
        Menu
    },
    mounted(){
  this.$store.dispatch('getHomeData')
  .then((response)=>{
    
    this.data = []
    this.data.push(...response.result.home_data)
   
  })
  .catch(()=>{ 
    this.ToastError('Problem loading Home')
  })
  .finally(()=>{
  })
}
}
</script>